module.exports = __webpack_public_path__ + "static/media/lien.12b4b3a0.png";